export default __webpack_public_path__ + "static/media/diving.56c9a7e6.jpg";